import { Icon, type IconProps } from "../icon";

const PATHS = [
  "M14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17C10 18.1046 10.8954 19 12 19C13.1046 19 14 18.1046 14 17ZM16 17C16 19.2091 14.2091 21 12 21C9.79086 21 8 19.2091 8 17C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17Z",
  "M21 16C21.5523 16 22 16.4477 22 17C22 17.5523 21.5523 18 21 18H15C14.4477 18 14 17.5523 14 17C14 16.4477 14.4477 16 15 16H21Z",
  "M6 12C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H3C2.44772 14 2 13.5523 2 13C2 12.4477 2.44772 12 3 12H6Z",
  "M2 15V10.8281C2.00008 10.0326 2.31637 9.26957 2.87891 8.70703L5.58594 6H5C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4H21C21.5523 4 22 4.44772 22 5C22 5.55228 21.5523 6 21 6H8.41406L4.29297 10.1211C4.1055 10.3086 4.00008 10.563 4 10.8281V15C4 15.5523 4.44772 16 5 16H9C9.55228 16 10 16.4477 10 17C10 17.5523 9.55228 18 9 18H5C3.34315 18 2 16.6569 2 15Z",
];

export function HatchbackIcon(props: IconProps) {
  return <Icon viewBox="0 0 24 24" paths={PATHS} {...props} />;
}
